// Import the functions you need from the SDKs you need
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyASlnnEnt7NNAXIofEUAUGXxD4wEwoNQTc",
  authDomain: "prabhu-labels.firebaseapp.com",
  projectId: "prabhu-labels",
  storageBucket: "prabhu-labels.appspot.com",
  messagingSenderId: "1085749002111",
  appId: "1:1085749002111:web:9efa8fa94090fcb5e8244a",
  measurementId: "G-QCJ90SLMVJ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);

// Helper function to upload image to Firebase Storage
export const uploadImageToFirebase = async (file) => {
  try {
    if (!file) return null;

    // Create a unique filename using timestamp
    const timestamp = Date.now();
    const fileName = `${timestamp}_${file.name}`;

    // Create a reference to the file location
    const storageRef = ref(storage, `images/${fileName}`);

    // Upload the file
    const snapshot = await uploadBytes(storageRef, file);

    // Get the download URL
    const downloadURL = await getDownloadURL(snapshot.ref);

    return downloadURL;
  } catch (error) {
    console.error("Error uploading image:", error);
    throw error;
  }
};

export { storage };
